import { Fragment } from 'react';

import { Card, FormItem, Text } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useUISchema } from '../hooks';
import { Schema } from '../queries';

interface Props {
  schemaId: string;
  schema: Schema;
  level?: number;
  path: string;
}

export function SchemaFormLabel({ path, schemaId, schema }: Props) {
  // Match exactly "step_{number}"
  const isStepNode = /^step_\d+$/.exec(path);
  const level = path.split('.').length;

  const { isOptional } = useUISchema({ path, schemaId });
  const { t } = useTranslation();

  /**
   * @todo the schema.title === 'Step 0' check is temporary until it's removed from the API.
   */
  if (!schema.title || schema.title === 'Step 0') {
    return null;
  }

  return (
    <Fragment>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <FormItem.Label
          style={{
            fontSize: schema.type === 'object' && isStepNode ? '16px' : 'inherit',
            fontWeight: schema.type === 'object' ? 'bold' : 'inherit',
          }}
        >
          {schema.title} {isOptional && `(${t('common.optional')})`}
        </FormItem.Label>

        {schema.description && <Text>{schema.description}</Text>}
      </div>

      {(level > 2 && schema.type === 'object') || (isStepNode && <Card.Separator />)}
    </Fragment>
  );
}
